<template>
	<div>{{ $t("pages.externalLink.description") }}</div>
</template>

<script>
export default {
  computed: {
    externalLink() {
      return this.$route.query.url;
    },
  },
  mounted() {
    window.location.href = this.externalLink;
  },
};
</script>

<style lang="scss" scoped></style>
